const crudConfig = {
    endpoint: 'codes',
    primaryKey: 'codeId',
    globalSearchFieldName: 'text',
    globalSearchQueryClass: 'ByGeneralProperties',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemId'],
            query: {
                filter: 'codeSystemId=#@codeSystemId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        fetchAllByCollection: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['partId'],
            query: {
                filter: 'partId=#@partId@#',
                property: 'queryClass=ByCodeCollection'
            }
        },
        fetchByConstraintTypeCode: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['codeId'],
            query: {
                filter: 'codeId=#@codeId@#',
                property: 'queryClass=PrimaryKey'
            }
        },
        fetchByConstraintTypeCodeSystem: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['codeSystemId'],
            query: {
                filter: 'codeSystemId=#@codeSystemId@#',
                property: 'queryClass=ByCodeSystemId'
            }
        },
        fetchByConstraintTypeConcept: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['conceptCodeId'],
            query: {
                filter: 'conceptCodeId=#@conceptCodeId@#',
                property: 'queryClass=ByConceptId'
            }
        },
        fetchByConstraintTypeValueSet: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['valueSetId'],
            query: {
                filter: 'valueSetId=#@valueSetId@#',
                property: 'queryClass=ByValueSetId'
            }
        },
        fetchByConstraintTypeList: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: false,
            args: ['listId'],
            query: {
                filter: 'listId=#@listId@#',
                property: 'queryClass=ByListId'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemId', 'vsDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds',
            args: ['codeSystemId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            args: ['codeSystemDoc']
        }
    }
};

export default crudConfig;
